export const DEFAULT_LANGUAGE = 'en'
export const FALLBACK_LANGUAGE = 'en'
export const SUPPORTED_LANGUAGES = 'en, zh_CN'

export const CURRENCY_CN = 'RMB'
export const CURRENCY_USA = 'USD'

export const COUNTRY_CN = 'CN'
export const COUNTRY_USA = 'USA'



// WEBPACK FOOTER //
// ./src/constants/trans.js